import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const WorkspaceProLayout = lazy(() =>
  import('../components/workspace-pro/WorkspaceProLayout').then((m) => ({ default: m.WorkspaceProLayout }))
)
const WorkProHubPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.HubPage }))
)
const WorkProWorkspaceListPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.WorkspaceListPage }))
)
const WorkProActivityPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.ActivityPage }))
)
const WorkProQuickStartPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.QuickStartPage }))
)
const WorkProChatPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.ChatPage }))
)
const WorkProDocumentsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.DocumentsPage }))
)
const WorkProToolsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.ToolsPage }))
)
const WorkProSearchPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.SearchPage }))
)
const WorkProCommunityPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.CommunityPage }))
)
const WorkProThemesPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.ThemesPage }))
)
const WorkProMembersPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.MembersPage }))
)
const WorkProInvitationsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.InvitationsPage }))
)
const WorkProProfilePage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.ProfilePage }))
)
const WorkProRagIndexPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.RagIndexPage }))
)
const WorkProAgentsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.AgentsPage }))
)
const WorkProChatHistoryPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.ChatHistoryPage }))
)
const WorkProSettingsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.WorkProSettingsPage }))
)
const WorkProPermissionsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.PermissionsPage }))
)
const WorkProWebAccessPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.WebAccessPage }))
)
const WorkProNotificationsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.NotificationsPage }))
)
const WorkProReportsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.ReportsPage }))
)
const WorkProIntegrationPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.WorkProIntegrationPage }))
)
const WorkProAuditTrailPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.WorkProAuditTrailPage }))
)
const WorkProModuleSettingsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.ModuleSettingsPage }))
)
const WorkProOutilsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.WorkProOutilsPage }))
)
const WorkProMyComplianceAssistantPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.MyComplianceAssistantPage }))
)
const WorkProSmartTaskPrioritizerPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.SmartTaskPrioritizerPage }))
)
const WorkProPersonalDashboardPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.PersonalDashboardPage }))
)
const WorkProPersonalRiskRadarPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.PersonalRiskRadarPage }))
)
const WorkProKnowledgeHubPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.KnowledgeHubPage }))
)
const WorkProMeetingActionsPage = lazy(() =>
  import('../pages/workspace-pro').then((m) => ({ default: m.MeetingActionsPage }))
)

export const workspaceProRoutes: RouteObject[] = [
  {
    path: '/workspace-pro',
    element: <WorkspaceProLayout />,
    children: [
      { index: true, element: <WorkProHubPage /> },
      // /workspace-pro/hub is an alias for the index — many docs and links use it.
      { path: 'hub', element: <WorkProHubPage /> },
      { path: 'workspaces', element: <WorkProWorkspaceListPage /> },
      { path: 'activity', element: <WorkProActivityPage /> },
      { path: 'quick-start', element: <WorkProQuickStartPage /> },
      { path: 'chat', element: <WorkProChatPage /> },
      { path: 'documents', element: <WorkProDocumentsPage /> },
      { path: 'tools', element: <WorkProToolsPage /> },
      { path: 'search', element: <WorkProSearchPage /> },
      { path: 'community', element: <WorkProCommunityPage /> },
      { path: 'themes', element: <WorkProThemesPage /> },
      { path: 'members', element: <WorkProMembersPage /> },
      { path: 'invitations', element: <WorkProInvitationsPage /> },
      { path: 'profile', element: <WorkProProfilePage /> },
      { path: 'rag-index', element: <WorkProRagIndexPage /> },
      { path: 'agents', element: <WorkProAgentsPage /> },
      { path: 'chat-history', element: <WorkProChatHistoryPage /> },
      { path: 'settings', element: <WorkProSettingsPage /> },
      { path: 'permissions', element: <WorkProPermissionsPage /> },
      { path: 'web-access', element: <WorkProWebAccessPage /> },
      { path: 'notifications', element: <WorkProNotificationsPage /> },
      { path: 'reports', element: <WorkProReportsPage /> },
      { path: 'integrations', element: <WorkProIntegrationPage /> },
      { path: 'audit-trail', element: <WorkProAuditTrailPage /> },
      { path: 'module-settings', element: <WorkProModuleSettingsPage /> },
      { path: 'outils', element: <WorkProOutilsPage /> },
      { path: 'my-compliance-assistant', element: <WorkProMyComplianceAssistantPage /> },
      { path: 'smart-task-prioritizer', element: <WorkProSmartTaskPrioritizerPage /> },
      { path: 'personal-dashboard', element: <WorkProPersonalDashboardPage /> },
      { path: 'personal-risk-radar', element: <WorkProPersonalRiskRadarPage /> },
      { path: 'knowledge-hub', element: <WorkProKnowledgeHubPage /> },
      { path: 'meeting-actions', element: <WorkProMeetingActionsPage /> },
    ],
  },
]
